import { defineStore } from "pinia";

// * STOREs
import { useStoreWorkList } from "@/stores/workListsStore";

import { usePatientStore } from "@/stores/patientStore";
// const patientStore = usePatientStore();

// del API
import { fetchAppointments, fetchPatientListFromSchedule, fetchPatientMasterList, fetchTodaysPatientList } from "../api/patientApi";

import moment from "moment";
import { extendMoment } from "moment-range";
var moment1 = extendMoment(moment);

// // console.log(" new MOMENT.js");
const currentDate = moment(Date.now()).format("MM/DD/YYYY");
// console.log("User's PATIENT Store =  currentDate : ", currentDate);

import { toast } from "vue3-toastify";

export const useUsersPatientsStore = defineStore("usersPatients", {
  state: () => ({
    patientIDStartList: [
      // 15225,27734,46190,40295,9939,26085,
    ], // users patient Id list

    todaysPatientList: [],
    patientListFromSchedule: [],

    masterPatientList: [],
    unfilteredMasterPatientList: [],

    patientList: [], // this will be the collection of completed Patients

    flatPatientList: [], // this will be the collection of completed Patients
    scheduledPatients: [], // this will be the collection of USERs scheduled Patients

    unassignedScheduledPatients: [], // this will be the MASTER list of unassigned Scheduled Patients

    patientArrayForControls: [],
    id: 0,
    unassignedPatients: [],
    assignedPatients: [],

    officesColors: [
      {
        text: "Creve Coeur",
        id: 1,
        color: "#1565C0",
      },
      {
        text: "Alton",
        id: 2,
        color: "#C62828",
      },
      {
        text: "Kennerly",
        id: 3,
        color: "#2E7D32",
      },
      {
        text: "Festus",
        id: 4,
        color: "#888a1c",
      },
    ],

    cliniciansColors: [
      {
        text: "Dr. Willey (Doctor)",
        id: 1,
        color: "#cc5c53",
        type: "doctor",
      },
      {
        text: "Dr. Kaiser  (Doctor)",
        id: 2,
        color: "#ff9747",
        type: "doctor",
      },
      {
        text: "Jennifer Lopez, (Lab Tech)",
        id: 3,
        color: "#8d7b17",
        type: "clinician",
      },
      {
        text: "Wayne Scrimsher  (NP)",
        id: 4,
        color: "#1B8A3E",
        type: "clinician",
      },
      {
        text: "Erin Holloway, (NP)",
        id: 5,
        color: "#00008B",
        type: "coder",
      },
      {
        text: "Becky Ganz , (NP)",
        id: 6,
        color: "#9b59b6",
        type: "coder",
      },
    ],

    appointmentsMaster: [
      {
        text: "THNG 2",
        officeId: 4,
        clinicianId: 4,
        personID: 46637,
        startDate: "2026-04-20T13:00:00Z",
        endDate: "2026-04-20T15:30:00Z",
      },
      {
        text: "SOMETHING 1",
        officeId: 4,
        clinicianId: 5,
        personID: 4805,
        startDate: "2026-04-14T13:00:00Z",
        endDate: "2026-04-14T15:30:00Z",
      },
      {
        text: "TEST 1",
        officeId: 1,
        clinicianId: 2,
        personID: 21140,
        startDate: "2026-04-17T13:00:00.000Z",
        endDate: "2026-04-17T15:30:00.000Z",
      },
      {
        text: "Follow-up Appointment - Jane Smith",
        officeId: 2,
        clinicianId: 1,
        personID: 25908,
        startDate: "2026-04-16T13:00:00.000Z",
        endDate: "2026-04-16T15:30:00.000Z",
      },
      {
        text: "RANDOM TESTING",
        officeId: 3,
        clinicianId: 1,
        personID: 15775,
        startDate: "2026-04-16T19:00:00Z",
        endDate: "2026-04-16T20:00:00Z",
      },
      {
        text: "EoD - Jane Smith",
        officeId: 2,
        clinicianId: 1,
        personID: 25908,
        startDate: "2026-04-17T20:00:00Z",
        endDate: "2026-04-17T21:30:00Z",
      },
      {
        text: "Patient Consultation - John Doe",
        officeId: 1,
        clinicianId: 2,
        personID: 21140,
        startDate: "2026-04-27T16:30:00.000Z",
        endDate: "2026-04-27T18:30:00.000Z",
      },
      {
        text: "Follow-up Appointment - Jane Smith",
        officeId: 2,
        clinicianId: 1,
        personID: 25908,
        startDate: "2026-04-27T19:00:00.000Z",
        endDate: "2026-04-27T20:00:00.000Z",
      },
      {
        text: "Physical Therapy Session - Bob Wilson",
        officeId: 1,
        clinicianId: 3,
        personID: 46637,
        startDate: "2026-04-27T21:30:00.000Z",
        endDate: "2026-04-27T22:30:00.000Z",
      },
      {
        text: "Lab Results Review - Mary Johnson",
        officeId: 3,
        clinicianId: 2,
        personID: 4805,
        startDate: "2026-04-28T17:00:00.000Z",
        endDate: "2026-04-28T18:00:00.000Z",
      },
      {
        text: "Surgery Consultation - David Brown",
        officeId: 2,
        clinicianId: 4,
        personID: 15775,
        startDate: "2026-04-28T19:00:00.000Z",
        endDate: "2026-04-28T20:35:00.000Z",
      },
      {
        text: "Coding Review Session",
        officeId: 1,
        clinicianId: 5,
        personID: 21140,
        startDate: "2026-04-28T21:30:00.000Z",
        endDate: "2026-04-28T22:45:00.000Z",
      },
      {
        allDay: false,
        text: "Becky Does THIIS",
        officeId: 1,
        clinicianId: 6,
        personID: 46637,
        startDate: "2026-05-01T08:00:00.000Z",
        endDate: "2026-05-01T17:00:00.000Z",
      },
      {
        allDay: false,
        text: "Dr",
        officeId: 2,
        clinicianId: 1,
        personID: 2659,
        startDate: "2026-04-08T13:00:00Z",
        endDate: "2026-04-08T16:00:00Z",
      },
      {
        allDay: false,
        text: "DR2",
        officeId: 3,
        clinicianId: 1,
        personID: 45278,
        startDate: "2026-04-09T14:30:00Z",
        endDate: "2026-04-09T14:45:00Z",
      },
      {
        allDay: false,
        text: "dr3",
        officeId: 4,
        clinicianId: 1,
        personID: 45922,
        startDate: "2026-04-10T14:30:00Z",
        endDate: "2026-04-10T14:45:00Z",
      },
      {
        allDay: false,
        text: "33333",
        description: "3333333",
        officeId: 1,
        clinicianId: 1,
        personID: 9794,
        startDate: "2026-04-06T14:30:00Z",
        endDate: "2026-04-06T14:45:00Z",
      },
      {
        allDay: false,
        text: "srt",
        officeId: 1,
        clinicianId: 1,
        personID: 13133,
        startDate: "2026-04-07T15:00:00Z",
        endDate: "2026-04-07T15:15:00Z",
      },
      {
        allDay: false,
        startDate: "2026-04-13T13:45:00.000Z",
        endDate: "2026-04-13T14:00:00.000Z",
        text: "1",
        officeId: 1,
        clinicianId: 1,
        personID: 21140,
      },
      {
        allDay: false,
        startDate: "2026-04-14T13:45:00.000Z",
        endDate: "2026-04-14T14:00:00.000Z",
        text: "2",
        officeId: 1,
        clinicianId: 1,
        personID: 3487,
      },
      {
        allDay: false,
        startDate: "2026-04-02T13:45:00.000Z",
        endDate: "2026-04-02T14:00:00.000Z",
        text: "1",
        officeId: 1,
        clinicianId: 1,
        personID: 21140,
      },
      {
        text: "Cod Session #1 8:00 AM local time (UTC-5)",
        officeId: 1,
        clinicianId: 1,
        personID: 21140,
        startDate: "2026-04-09T13:00:00.000Z",
        endDate: "2026-04-09T14:00:00.000Z",
      },
      {
        text: "Cod Session #2 9:00 AM local time (UTC-5)",
        officeId: 1,
        clinicianId: 1,
        personID: 21140,
        startDate: "2026-04-09T14:00:00.000Z",
        endDate: "2026-04-09T15:00:00.000Z",
      },
      {
        text: "Cod Session  #3 1:00 PM local time (UTC-5)",
        officeId: 1,
        clinicianId: 1,
        personID: 21140,
        startDate: "2026-04-09T18:00:00.000Z",
        endDate: "2026-04-09T19:00:00.000Z",
      },
      {
        text: "Cod Session #4 4:00 PM local time (UTC-5)",
        officeId: 1,
        clinicianId: 1,
        personID: 21140,
        startDate: "2026-04-09T21:00:00.000Z",
        endDate: "2026-04-09T21:30:00.000Z",
      },
      {
        text: " Session #1 8:00 AM local time (UTC-5)",
        officeId: 1,
        clinicianId: 2,
        personID: 21140,
        startDate: "2026-04-09T13:00:00.000Z",
        endDate: "2026-04-09T14:00:00.000Z",
      },
      {
        text: " Session #2 9:00 AM local time (UTC-5)",
        officeId: 1,
        clinicianId: 2,
        personID: 21140,
        startDate: "2026-04-09T14:00:00.000Z",
        endDate: "2026-04-09T15:00:00.000Z",
      },
      {
        text: " Session #3 local time (UTC-5)",
        officeId: 1,
        clinicianId: 3,
        personID: 21140,
        startDate: "2026-04-09T14:00:00.000Z",
        endDate: "2026-04-09T15:00:00.000Z",
      },
      {
        text: "Cod Session  #3 1:00 PM local time (UTC-5)",
        officeId: 1,
        clinicianId: 4,
        personID: 27734,
        startDate: "2026-04-09T18:00:00.000Z",
        endDate: "2026-04-09T19:00:00.000Z",
      },
      {
        text: "ZULU Convert",
        officeId: 1,
        clinicianId: 3,
        personID: 27734,
        startDate: "2026-04-09T20:00:00Z",
        endDate: "2026-04-09T21:15:00Z",
      },
      {
        text: "Cod Session #1 8:00 AM local time (UTC-5)",
        officeId: 1,
        clinicianId: 1,
        personID: 21140,
        startDate: "2026-04-20T13:00:00.000Z",
        endDate: "2026-04-20T14:00:00.000Z",
      },
      {
        text: "Cod Session #2 9:00 AM local time (UTC-5)",
        officeId: 1,
        clinicianId: 1,
        personID: 21140,
        startDate: "2026-04-20T14:00:00.000Z",
        endDate: "2026-04-20T15:00:00.000Z",
      },
      {
        text: "Cod Session  #3 1:00 PM local time (UTC-5)",
        officeId: 1,
        clinicianId: 1,
        personID: 21140,
        startDate: "2026-04-20T18:00:00.000Z",
        endDate: "2026-04-20T19:00:00.000Z",
      },
      {
        text: "Cod Session #4 4:00 PM local time (UTC-5)",
        officeId: 1,
        clinicianId: 1,
        personID: 21140,
        startDate: "2026-04-20T21:00:00.000Z",
        endDate: "2026-04-20T21:30:00.000Z",
      },
      {
        text: " Session #1 8:00 AM local time (UTC-5)",
        officeId: 1,
        clinicianId: 2,
        personID: 21140,
        startDate: "2026-04-20T13:00:00.000Z",
        endDate: "2026-04-20T14:00:00.000Z",
      },
      {
        text: " Session #2 9:00 AM local time (UTC-5)",
        officeId: 1,
        clinicianId: 2,
        personID: 21140,
        startDate: "2026-04-20T14:00:00.000Z",
        endDate: "2026-04-20T15:00:00.000Z",
      },
      {
        text: " Session #3 local time (UTC-5)",
        officeId: 1,
        clinicianId: 3,
        personID: 21140,
        startDate: "2026-04-20T14:00:00.000Z",
        endDate: "2026-04-20T15:00:00.000Z",
      },
      {
        text: "Cod Session  #3 1:00 PM local time (UTC-5)",
        officeId: 1,
        clinicianId: 4,
        personID: 27734,
        startDate: "2026-04-20T18:00:00.000Z",
        endDate: "2026-04-20T19:00:00.000Z",
      },
      {
        text: "ZULU Convert",
        officeId: 1,
        clinicianId: 3,
        personID: 27734,
        startDate: "2026-04-20T20:00:00Z",
        endDate: "2026-04-20T21:15:00Z",
      },
      {
        text: "Cod Session #1 8:00 AM local time (UTC-5)",
        officeId: 1,
        clinicianId: 1,
        personID: 21140,
        startDate: "2026-04-30T13:00:00.000Z",
        endDate: "2026-04-30T14:00:00.000Z",
      },
      {
        text: "Cod Session #2 9:00 AM local time (UTC-5)",
        officeId: 1,
        clinicianId: 1,
        personID: 21140,
        startDate: "2026-04-30T14:00:00.000Z",
        endDate: "2026-04-30T15:00:00.000Z",
      },
      {
        text: "Cod Session  #3 1:00 PM local time (UTC-5)",
        officeId: 1,
        clinicianId: 1,
        personID: 21140,
        startDate: "2026-04-30T18:00:00.000Z",
        endDate: "2026-04-30T19:00:00.000Z",
      },
      {
        text: "Cod Session #4 4:00 PM local time (UTC-5)",
        officeId: 1,
        clinicianId: 1,
        personID: 21140,
        startDate: "2026-04-30T21:00:00.000Z",
        endDate: "2026-04-30T21:30:00.000Z",
      },
      {
        text: " Session #1 8:00 AM local time (UTC-5)",
        officeId: 1,
        clinicianId: 2,
        personID: 21140,
        startDate: "2026-04-30T13:00:00.000Z",
        endDate: "2026-04-30T14:00:00.000Z",
      },
      {
        text: " Session #2 9:00 AM local time (UTC-5)",
        officeId: 1,
        clinicianId: 2,
        personID: 21140,
        startDate: "2026-04-30T14:00:00.000Z",
        endDate: "2026-04-30T15:00:00.000Z",
      },
      {
        text: " Session #3 local time (UTC-5)",
        officeId: 1,
        clinicianId: 3,
        personID: 21140,
        startDate: "2026-04-30T14:00:00.000Z",
        endDate: "2026-04-30T15:00:00.000Z",
      },
      {
        text: "Cod Session  #3 1:00 PM local time (UTC-5)",
        officeId: 1,
        clinicianId: 4,
        personID: 27734,
        startDate: "2026-04-30T18:00:00.000Z",
        endDate: "2026-04-30T19:00:00.000Z",
      },
      {
        text: "ZULU Convert",
        officeId: 1,
        clinicianId: 3,
        personID: 27734,
        startDate: "2026-04-30T20:00:00Z",
        endDate: "2026-04-30T21:15:00Z",
      },
      {
        text: "ZULU TEST Convert",
        officeId: 1,
        clinicianId: 3,
        personID: 27734,
        startDate: "2026-04-01T13:00:00Z",
        endDate: "2026-04-01T14:15:00Z",
      },
      {
        text: "22222222 ZULU TEST Convert",
        officeId: 1,
        clinicianId: 5,
        personID: 27734,
        startDate: "2026-04-02T03:22:26-12:00",
        endDate: "2026-04-02T03:22:26-12:00",
      },
      {
        allDay: false,
        text: "test 1",
        description: "test",
        officeId: 1,
        clinicianId: 4,
        personID: 2659,
        startDate: "2026-04-03T13:15:00Z",
        endDate: "2026-04-03T13:30:00Z",
      },
      {
        allDay: false,
        text: "1122",
        officeId: 1,
        clinicianId: 1,
        personID: 25908,
        startDate: "2026-04-03T13:15:00Z",
        endDate: "2026-04-03T13:30:00Z",
      },
      {
        allDay: false,
        text: "sdff",
        officeId: 1,
        clinicianId: 1,
        personID: 45523,
        startDate: "2026-04-03T14:30:00Z",
        endDate: "2026-04-03T15:45:00Z",
      },
      {
        allDay: false,
        text: "Dr",
        officeId: 2,
        clinicianId: 1,
        personID: 2659,
        startDate: "2026-04-08T13:00:00Z",
        endDate: "2026-04-08T16:00:00Z",
      },
      {
        allDay: false,
        text: "DR2",
        officeId: 3,
        clinicianId: 1,
        personID: 45278,
        startDate: "2026-04-09T14:30:00Z",
        endDate: "2026-04-09T14:45:00Z",
      },
      {
        allDay: false,
        text: "dr3",
        officeId: 4,
        clinicianId: 1,
        personID: 45922,
        startDate: "2026-04-10T14:30:00Z",
        endDate: "2026-04-10T14:45:00Z",
      },
      {
        allDay: false,
        text: "33333",
        description: "3333333",
        officeId: 1,
        clinicianId: 1,
        personID: 9794,
        startDate: "2026-04-06T14:30:00Z",
        endDate: "2026-04-06T14:45:00Z",
      },
      {
        allDay: false,
        text: "srt",
        officeId: 1,
        clinicianId: 1,
        personID: 13133,
        startDate: "2026-04-07T15:00:00Z",
        endDate: "2026-04-07T15:15:00Z",
      },
      {
        allDay: false,
        startDate: "2026-04-21T14:00:00.000Z",
        endDate: "2026-04-21T14:15:00.000Z",
        text: "DTR",
        clinicianId: 1,
        officeId: 1,
        personID: 21140,
      },
      {
        allDay: false,
        startDate: "2026-04-22T14:00:00.000Z",
        endDate: "2026-04-22T14:15:00.000Z",
        text: "DR2             2           ",
        clinicianId: 1,
        officeId: 1,
        personID: 21140,
      },
      {
        allDay: false,
        startDate: "2026-04-21T14:00:00.000Z",
        endDate: "2026-04-21T14:15:00.000Z",
        text: "22",
        clinicianId: 2,
        officeId: 1,
        personID: 3487,
      },
      {
        allDay: false,
        startDate: "2026-04-22T14:00:00.000Z",
        endDate: "2026-04-22T14:15:00.000Z",
        clinicianId: 3,
        officeId: 1,
        personID: 2659,
        text: "2222222222222",
      },
      {
        allDay: false,
        startDate: "2026-04-23T14:00:00.000Z",
        endDate: "2026-04-23T14:15:00.000Z",
        clinicianId: 5,
        officeId: 1,
        personID: 315,
        text: "232SS",
      },
      {
        allDay: false,
        startDate: "2026-04-21T14:00:00.000Z",
        endDate: "2026-04-21T14:15:00.000Z",
        text: "232QAA",
        clinicianId: 6,
        officeId: 2,
        personID: 315,
      },
      {
        allDay: false,
        startDate: "2026-04-23T14:00:00.000Z",
        endDate: "2026-04-23T14:15:00.000Z",
        clinicianId: 4,
        officeId: 3,
        personID: 2659,
        text: "A232",
      },
      {
        allDay: false,
        startDate: "2026-04-15T14:00:00.000Z",
        endDate: "2026-04-15T14:15:00.000Z",
        clinicianId: 1,
        officeId: 4,
        text: "DR",
        personID: 315,
      },
      {
        allDay: false,
        startDate: "2026-04-24T14:00:00.000Z",
        endDate: "2026-04-24T14:15:00.000Z",
        text: "SDFSD",
        clinicianId: 2,
        officeId: 3,
        personID: 45487,
      },
      {
        allDay: false,
        startDate: "2026-04-03T14:45:00.000Z",
        endDate: "2026-04-03T15:00:00.000Z",
        text: "Test",
        description: "Some Test",
        officeId: 1,
        clinicianId: 1,
        personID: 21140,
      },
      {
        startDate: "2026-04-03T15:00:00.000Z",
        endDate: "2026-04-03T15:15:00.000Z",
        useCurrentPatient: true,
        personID: 43787,
        text: "SCHULTZ, THOMAS",
        officeId: 1,
        clinicianId: 3,
      },
      {
        startDate: "2026-04-06T15:00:00.000Z",
        endDate: "2026-04-06T15:15:00.000Z",
        useCurrentPatient: true,
        personID: 43787,
        text: "SCHULTZ, THOMAS",
        officeId: 2,
        clinicianId: 2,
      },
      {
        startDate: "2026-04-03T18:30:00.000Z",
        endDate: "2026-04-03T18:45:00.000Z",
        useCurrentPatient: true,
        personID: 38698,
        text: "JONES, ELVIS",
        officeId: 3,
        clinicianId: 2,
      },
      {
        allDay: false,
        startDate: "2026-04-06T13:30:00.000Z",
        endDate: "2026-04-06T13:45:00.000Z",
        officeId: 4,
        personID: 38698,
        text: "JONES, ELVIS",
        useCurrentPatient: true,
        clinicianId: 1,
      },
      {
        allDay: false,
        startDate: "2026-04-14T16:45:00Z",
        endDate: "2026-04-14T17:00:00Z",
        officeId: 1,
        useCurrentPatient: true,
        personID: 26085,
        text: "BELL, LINDA",
        clinicianId: 1,
      },
      {
        allDay: false,
        startDate: "2026-04-10T13:00:00Z",
        endDate: "2026-04-10T14:00:00Z",
        officeId: 2,
        personID: 26085,
        text: "BELL, LINDA",
        useCurrentPatient: true,
        clinicianId: 2,
      },
      {
        allDay: false,
        startDate: "2026-04-13T16:45:00Z",
        endDate: "2026-04-13T17:00:00Z",
        officeId: 3,
        personID: 26085,
        text: "BELL, LINDA",
        useCurrentPatient: true,
        clinicianId: 3,
      },
      {
        allDay: false,
        startDate: "2026-04-15T16:45:00Z",
        endDate: "2026-04-15T17:00:00Z",
        officeId: 4,
        personID: 26085,
        text: "BELL, LINDA",
        useCurrentPatient: true,
        clinicianId: 5,
      },
    ],

    pendingAppointment: null,

    testPatientAPPData: [
      {
        startDate: "2026-04-13T18:30:00Z",
        endDate: "2026-04-13T18:45:00Z",
        useCurrentPatient: true,
        personID: 38698,
        text: "JONES, ELVIS",
        officeId: 1,
        clinicianId: 1,
        allDay: false,
        recurrenceRule: "",
      },
      {
        allDay: false,
        startDate: "2026-04-14T13:30:00Z",
        endDate: "2026-04-14T13:45:00Z",
        officeId: 2,
        personID: 38698,
        text: "JONES, ELVIS",
        useCurrentPatient: true,
        clinicianId: 1,
      },
      {
        startDate: "2026-04-15T18:30:00Z",
        endDate: "2026-04-15T18:45:00Z",
        useCurrentPatient: true,
        personID: 38698,
        text: "JONES, ELVIS",
        officeId: 1,
        clinicianId: 1,
        allDay: false,
        recurrenceRule: "",
      },
      {
        allDay: false,
        startDate: "2026-04-16T13:30:00Z",
        endDate: "2026-04-16T13:45:00Z",
        officeId: 2,
        personID: 38698,
        text: "JONES, ELVIS",
        useCurrentPatient: true,
        clinicianId: 1,
      },
    ],
  }),
  // getters
  // actions
  actions: {
    async loadAppointments() {
      const result = await fetchAppointments();
      if (result.ok && result.payload) {
        this.appointmentsMaster = result.payload;
      }
      return result;
    },
    addAppointment(appointment) {
      this.appointmentsMaster.push({ ...appointment });
      this.testPatientAPPData.push({ ...appointment });
      // ADD API CALL to SAVE APPOINTMENT to DB
      console.log(" ***  addAppointment  to Store + API CALL to SAVE APPOINTMENT to DB  *** ");
      console.log(appointment);
      // Save appointmentsMaster array to list.txt
      const jsStr = JSON.stringify(this.appointmentsMaster, null, 2).replace(/"([^"]+)":/g, "$1:");
      const blob = new Blob([jsStr], {
        type: "text/plain",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "list.txt";
      a.click();
      URL.revokeObjectURL(url);
    },
    async getPatientListFromSchedule() {
      // console.log("getPatientListFromSchedule");
      // console.log(this.patientListFromSchedule);

      const result = await fetchPatientListFromSchedule();

      if (result.ok && result.payload) {
        this.patientListFromSchedule = result.payload;
        // console.log("this.patientListFromSchedule");
        // console.log(this.patientListFromSchedule);
        return result;
      }
      return result;
    },
    async getPatientMasterList() {
      // console.log("getPatientMasterList");
      // console.log(this.masterPatientList);

      const result = await fetchPatientMasterList();

      if (result.ok && result.payload) {
        this.masterPatientList = result.payload;
        // console.log("this.masterPatientList");
        // console.log(this.masterPatientList);
        // console.log("this.masterPatientList.length");

        this.unfilteredMasterPatientList = result.payload;

        // & nextAppointment Filters  01/01/1900
        // ! charliie adams   27734
        // this.masterPatientList = this.masterPatientList.filter((x) => x.nextAppointment !== "1900-01-01T00:00:00Z");

        // console.log("list  masterPatientList: ", this.masterPatientList?.length);

        // this.patientIDStartList.forEach((patientId) => {
        //   const foundPatientIndex = this.masterPatientList.findIndex((patient) => patient.personID === patientId);
        //   if (foundPatientIndex !== -1) {
        //     const foundPatient = this.masterPatientList[foundPatientIndex];
        //     console.log("Found patient:", foundPatient);

        //     console.log(" TURN OFF  splice of masterPatientList ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++");
        //     // this.masterPatientList.splice(foundPatientIndex, 1);
        //     // this.scheduledPatients.push({ ...foundPatient, isScheduledTEMP: true, fromMaster: true });
        //   }
        // });

        return result;
      }
      return result;
    },

    // &^  Builds Patient Obj Array from User's Session Data  patientIdStartList
    async getTodaysPatientList() {
      // console.log("getTodaysPatientList");
      // console.log(this.masterPatientList);
      const result = await fetchTodaysPatientList();

      if (result.ok && result.payload) {
        this.todaysPatientList = result.payload;
        // console.log("this.todaysPatientList");
        // console.log(this.todaysPatientList);

        // foreach patient in todaysPatientList
        this.todaysPatientList.forEach((patient) => {
          // this.scheduledPatients.push({ ...patient, isScheduledTEMP: true, fromToday: true });
          // console.log("  Assinging Patient " + patient.personID + " to Users Scheduled Patients");
          this.assignTodaysPatient(patient.personID);
        });

        // this.scheduledPatients = result.payload;
        // console.log("ADDING   users todaysPatList to this.scheduledPatients");
        // console.log(this.scheduledPatients);

        return result;
      }
      return result;
    },

    assignMasterPatient(patientId, isScheduled) {
      const patient = this.masterPatientList.find((p) => p.personID === patientId);
      if (patient) {
        patient.addToSchedule = true;
        patient.isScheduledTEMP = true;
        if (isScheduled) {
          this.scheduledPatients.push({
            ...patient,
            isScheduledTEMP: true,
            fromSchedule: true,
          });
        } else {
          this.scheduledPatients.push({
            ...patient,
            isScheduledTEMP: true,
            fromMaster: true,
          });
        }

        // Remove from unassigned
        // this.masterPatientList = this.masterPatientList.filter((p) => p.personID !== patientId);
        // add boolean to disable the created ADD btn

        // Add to assigned
      }
    },
    unassignMasterPatient(patientId) {
      const patient = this.scheduledPatients.find((p) => p.personID === patientId);
      if (patient) {
        // Remove from scheduled patients
        this.scheduledPatients = this.scheduledPatients.filter((p) => p.personID !== patientId);

        // Find and update the patient in masterPatientList
        const masterPatient = this.masterPatientList.find((p) => p.personID === patientId);
        if (masterPatient) {
          masterPatient.addToSchedule = false;
          masterPatient.isScheduledTEMP = false;
        }
      }
    },
    assignScheduledPatient(patientId) {
      const patient = this.masterPatientList.find((p) => p.personID === patientId);
      if (patient) {
        patient.addToSchedule = true;
        // Remove from unassigned
        // this.patientListFromSchedule = this.patientListFromSchedule.filter((p) => p.personID !== patientId);
        // Add to assigned
        // this.scheduledPatients.push({ ...patient, isScheduledTEMP: true, fromSchedule: true });
        this.scheduledPatients.push({ ...patient });
      }
    },
    unassignScheduledPatient(patientId) {
      const patient = this.scheduledPatients.find((p) => p.personID === patientId);
      if (patient) {
        // Remove from assigned
        this.scheduledPatients = this.scheduledPatients.filter((p) => p.personID !== patientId);
        // Add to unassigned
        this.patientListFromSchedule.push({
          ...patient,
          isScheduledTEMP: false,
          fromSchedule: false,
        });
      }
    },
    assignTodaysPatient(patientId) {
      const patient = this.todaysPatientList.find((p) => p.personID === patientId);
      if (patient) {
        // Remove from unassigned
        this.todaysPatientList = this.todaysPatientList.filter((p) => p.personID !== patientId);
        // Add to assigned
        this.scheduledPatients.push({
          ...patient,
          isScheduledTEMP: true,
          fromToday: true,
        });
      }
    },
    unassignTodaysPatient(patientId) {
      const patient = this.scheduledPatients.find((p) => p.personID === patientId);
      if (patient) {
        // Remove from assigned
        this.scheduledPatients = this.scheduledPatients.filter((p) => p.personID !== patientId);
        // Add to unassigned
        this.todaysPatientList.push({
          ...patient,
          isScheduledTEMP: false,
          fromToday: false,
        });
      }
    },
    setUsersPatientIdList(list) {
      // console.log("                                          USER Pat store   setUsersPatientIdList");
      // console.log(list);
      this.patientIDStartList = list;
    },
    addCurrentPatient(patient) {
      this.patientList.push({
        patient,
        id: patient.personID,
        currentPatient: false,
      });

      patient.isScheduledTEMP = true; // Manually set isScheduled to true
      // & new patient list FLAT
      this.flatPatientList.push(patient);
      // Add to assigned

      // this.flatPatientList.push({ ...patient, isScheduled: true }); // &  isScheduled: (In-memory property)

      // console.log(" ***  isScheduled *** MANUALLY ADDED to PATIENT  ");

      // console.log("this.flatPatientList");
      // console.dir(this.flatPatientList);

      // &^ Scheduled Patients
      this.scheduledPatients = this.flatPatientList.filter((p) => p.isScheduledTEMP); // &  TEMPORARY property  :  isScheduledTEMP

      // const workListStore = useStoreWorkList();
      // ! TODO
      // this.unassignedScheduledPatients = fetchPatientListFromSchedule(); //this.flatPatientList.filter((p) => !p.isScheduledTEMP);
      // this.unassignedScheduledPatients = workListStore.primaryWidgetSummaryList[0]?.widgetGridDataArray;

      this.unassignedScheduledPatients = this.masterPatientList.filter((p) => !p.isAssigned);
      // console.log("this.unassignedScheduledPatients");
      // console.log(this.unassignedScheduledPatients);

      // After fetching, populate the separate arrays
      this.unassignedPatients = this.patientList.filter((p) => !p.isAssigned);
      this.assignedPatients = this.patientList.filter((p) => p.isAssigned);

      // const tTest =  JSON.stringify(JSON.parse(this.patientList))
      //  consol   e.log(' CLONe for CONTROLs  this.patientArrayForControls = this.patientList')
      this.patientArrayForControls = this.patientList;
      // console.log('this.patientList')
      // console.log(this.patientList)
      // console.log('this.patientArrayForControls')
      // console.log(this.patientArrayForControls)
    },

    updatePatient(patient) {
      // console.log(' updatePatient    Patient    id > ')
      const index = this.patientList.findIndex((obj) => obj.id === patient.id);
      if (index !== -1) {
        this.patientList[index] = {
          ...this.patientList[index],
          ...patient,
        };
      }
    },
    deletePatient(itemID) {
      // console.log(' DELETE Patient    id > ')
      // console.log(itemID)
      this.patientList = this.patientList.filter((object) => object.id !== itemID);
    },
    toggleCurrent(idToFind) {
      // console.log(' toggleCurrent    Patient    idToFind > ')
      // console.log(idToFind)

      const todo = this.patientList.find((obj) => obj.id === idToFind);
      if (todo) {
        todo.currentPatient = !todo.currentPatient;
      }
    },
    // store NEW Mutation
    addPatientToArray(patient) {
      // console.log("***STORE SETTER ***********");
      // console.log(patient);
      // console.log("<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<");
      this.patientArrayForControls.push(patient);
    },
  },
  getters: {
    getAppointments: (state) => state.appointmentsMaster,
    getAppointmentsByCurrentPatient: (state) => {
      const patientStore = usePatientStore();
      if (!patientStore.currentPatient?.personID) return [];
      return state.appointmentsMaster.filter((a) => a.personID === patientStore.currentPatient.personID);
    },
  },
});
